(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  };

  var initAnnouncements = function (root) {
    (root || document).querySelectorAll('[data-lf-rotate]').forEach(function (bar) {
      if (bar.dataset.lfReady) return;
      bar.dataset.lfReady = '1';
      var slides = bar.querySelectorAll('.lf-ann__slide');
      if (slides.length < 2) return;
      var delay = parseInt(bar.dataset.lfRotate, 10) || 5000;
      var index = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active')) index = i;
      });
      bar._lfTimer = setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, delay);
    });
  };

  var stopAnnouncements = function (root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-lf-rotate]').forEach(function (bar) {
      if (bar._lfTimer) {
        clearInterval(bar._lfTimer);
        bar._lfTimer = null;
      }
    });
  };

  var initCopy = function (root) {
    (root || document).querySelectorAll('[data-lf-copy]').forEach(function (btn) {
      if (btn.dataset.lfReady) return;
      btn.dataset.lfReady = '1';
      btn.addEventListener('click', function () {
        var code = btn.dataset.lfCopy;
        var done = function () {
          btn.classList.add('is-copied');
          clearTimeout(btn._lfTimer);
          btn._lfTimer = setTimeout(function () {
            btn.classList.remove('is-copied');
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'absolute';
          field.style.left = '-9999px';
          document.body.appendChild(field);
          field.select();
          try {
            document.execCommand('copy');
          } catch (e) {}
          document.body.removeChild(field);
          done();
        }
      });
    });
  };

  var initGallery = function (gallery) {
    if (!gallery || gallery.dataset.lfReady) return;
    gallery.dataset.lfReady = '1';
    var track = gallery.querySelector('[data-lf-gallery-track]');
    var thumbs = gallery.querySelectorAll('[data-lf-thumb]');
    if (!track) return;

    var setActive = function (index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', parseInt(thumb.dataset.lfThumb, 10) === index);
      });
    };

    var goTo = function (index, smooth) {
      var slide = track.children[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(index);
    };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.lfThumb, 10));
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var width = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / width));
        ticking = false;
      });
    }, { passive: true });

    gallery._lfGoTo = goTo;
    gallery._lfGoToMedia = function (mediaId) {
      if (!mediaId) return;
      var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) goTo(parseInt(slide.dataset.index, 10));
    };
  };

  var initProduct = function (product) {
    if (!product || product.dataset.lfReady) return;
    product.dataset.lfReady = '1';
    var dataEl = product.querySelector('[data-lf-variants]');
    var variants = [];
    try {
      variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
    } catch (e) {
      variants = [];
    }
    var gallery = product.querySelector('[data-lf-gallery]');
    initGallery(gallery);

    var input = product.querySelector('[data-lf-variant-input]');
    var price = product.querySelector('[data-lf-price]');
    var compare = product.querySelector('[data-lf-compare]');
    var atc = product.querySelector('[data-lf-atc]');
    var atcLabel = product.querySelector('[data-lf-atc-label]');

    var update = function (variantId) {
      var variant = null;
      variants.forEach(function (v) {
        if (String(v.id) === String(variantId)) variant = v;
      });
      if (!variant) return;

      product.querySelectorAll('.lf-pack').forEach(function (pack) {
        var radio = pack.querySelector('[data-lf-variant]');
        pack.classList.toggle('is-selected', radio && String(radio.value) === String(variant.id));
      });

      if (input) input.value = variant.id;
      if (price) price.textContent = variant.price;
      if (compare) {
        if (variant.compare) {
          compare.textContent = variant.compare;
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
      if (atc) {
        var showPrice = atc.dataset.showPrice === 'true';
        if (variant.available) {
          atc.disabled = false;
          atc.removeAttribute('aria-disabled');
          if (atcLabel) atcLabel.textContent = atc.dataset.label + (showPrice ? ' · ' + variant.price : '');
        } else {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = atc.dataset.soldout;
        }
      }
      if (gallery && gallery._lfGoToMedia) gallery._lfGoToMedia(variant.media);

      if (window.history && window.history.replaceState && product.dataset.url) {
        var url = product.dataset.url + '?variant=' + variant.id;
        window.history.replaceState({ path: url }, '', url);
      }
    };

    product.querySelectorAll('[data-lf-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) update(radio.value);
      });
    });
  };

  var initSliders = function (root) {
    (root || document).querySelectorAll('[data-lf-slider]').forEach(function (slider) {
      if (slider.dataset.lfReady) return;
      slider.dataset.lfReady = '1';
      var slides = slider.querySelectorAll('[data-lf-slide]');
      var nav = slider.querySelector('.lf-mini-reviews__nav');
      if (!slides.length) return;
      var index = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active')) index = i;
      });
      slides[index].classList.add('is-active');
      if (slides.length < 2) {
        if (nav) nav.hidden = true;
        return;
      }
      var show = function (next) {
        slides[index].classList.remove('is-active');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
      };
      var prev = slider.querySelector('[data-lf-prev]');
      var nextBtn = slider.querySelector('[data-lf-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    });
  };

  var refreshCartTimer = null;
  var refreshCartPill = function () {
    clearTimeout(refreshCartTimer);
    refreshCartTimer = setTimeout(function () {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var html = data && data['cart-icon-bubble'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.shopify-section');
          if (section) bubble.innerHTML = section.innerHTML;
        })
        .catch(function () {});
    }, 120);
  };

  var formatDay = function (date) {
    return date.getDate();
  };

  var addDays = function (date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  };

  var initCalculator = function (calc) {
    if (!calc || calc.dataset.lfReady) return;
    calc.dataset.lfReady = '1';
    var months = (calc.dataset.months || 'Jan,Fev,Mar,Abr,Mai,Jun,Jul,Ago,Set,Out,Nov,Dez').split(',');
    var form = calc.querySelector('[data-lf-calc-form]');
    var lmpInput = calc.querySelector('[data-lf-calc-lmp]');
    var cycleInput = calc.querySelector('[data-lf-calc-cycle]');
    var lutealInput = calc.querySelector('[data-lf-calc-luteal]');
    var windowEl = calc.querySelector('[data-lf-calc-window]');
    var ovEl = calc.querySelector('[data-lf-calc-ov]');
    var nextEl = calc.querySelector('[data-lf-calc-next]');
    var cal = calc.querySelector('[data-lf-calc-cal]');
    if (!form || !lmpInput) return;

    var today = new Date();
    var defaultLmp = addDays(new Date(today.getFullYear(), today.getMonth(), today.getDate()), -14);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    if (!lmpInput.value) {
      lmpInput.value = defaultLmp.getFullYear() + '-' + pad(defaultLmp.getMonth() + 1) + '-' + pad(defaultLmp.getDate());
    }

    var render = function () {
      var parts = (lmpInput.value || '').split('-');
      if (parts.length !== 3) return;
      var lmp = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      if (isNaN(lmp.getTime())) return;
      var cycle = (cycleInput && parseInt(cycleInput.value, 10)) || 28;
      var luteal = (lutealInput && parseInt(lutealInput.value, 10)) || 14;
      var ovOffset = Math.max(cycle - luteal, 1);
      var ov = addDays(lmp, ovOffset);
      var fertileStart = addDays(ov, -5);
      var next = addDays(lmp, cycle);

      if (windowEl) {
        var startLabel = formatDay(fertileStart) + (fertileStart.getMonth() !== ov.getMonth() ? ' ' + months[fertileStart.getMonth()] : '');
        windowEl.textContent = startLabel + ' - ' + formatDay(ov) + ' ' + months[ov.getMonth()];
      }
      if (ovEl) ovEl.textContent = formatDay(ov) + ' ' + months[ov.getMonth()];
      if (nextEl) nextEl.textContent = formatDay(next) + ' ' + months[next.getMonth()];

      if (cal) {
        var labelPeriod = cal.dataset.labelPeriod || '';
        var labelFertile = cal.dataset.labelFertile || '';
        var labelOv = cal.dataset.labelOv || '';
        var total = ovOffset + 1;
        var fragment = document.createDocumentFragment();
        for (var i = 0; i <= total; i++) {
          var day = addDays(lmp, i);
          var li = document.createElement('li');
          var cls = 'lf-day';
          var tag = '';
          if (i === 0) {
            cls += ' is-period';
            tag = labelPeriod;
          } else if (i === ovOffset) {
            cls += ' is-ov';
            tag = labelOv;
          } else if (i >= ovOffset - 5 && i < ovOffset) {
            cls += ' is-fertile';
            tag = labelFertile;
          }
          if (i === total) cls += ' lf-hide-desktop';
          li.className = cls;
          var num = document.createElement('span');
          num.className = 'lf-day__num';
          num.textContent = day.getDate();
          li.appendChild(num);
          if (tag) {
            var tagEl = document.createElement('span');
            tagEl.className = 'lf-day__tag';
            tagEl.textContent = tag;
            li.appendChild(tagEl);
          }
          fragment.appendChild(li);
        }
        cal.innerHTML = '';
        cal.appendChild(fragment);
      }
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      render();
      var result = calc.querySelector('.lf-calc__result');
      if (result && window.matchMedia('(max-width: 749px)').matches) {
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    [lmpInput, cycleInput, lutealInput].forEach(function (field) {
      if (field) field.addEventListener('change', render);
    });
    render();
  };

  var initAll = function (root) {
    var scope = root || document;
    initAnnouncements(scope);
    initCopy(scope);
    initSliders(scope);
    scope.querySelectorAll('[data-lf-product]').forEach(initProduct);
    scope.querySelectorAll('[data-lf-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-lf-calc]').forEach(initCalculator);
  };

  ready(function () {
    initAll(document);

    document.addEventListener('cartUpdated', refreshCartPill);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartPill);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      stopAnnouncements(event.target);
    });
  });
})();

(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  var GROUPS = [
    ['.lf-products__grid > li, .lf-related__grid > li, .lf-coll__grid > li, .lf-blog-posts__grid > li, .lf-blog__grid > *, .lf-blog__list > *', 'up'],
    ['.lf-features__grid > *, .lf-why__list > *, .lf-steps__list > *, .lf-guide__grid > *, .lf-reviews__grid > *', 'up'],
    ['.lf-faq__list > *, .lf-stat-grid > *, .lf-contact__channels > *, .lf-desc__specs > *', 'up'],
    ['.lf-head, .lf-contact__form-wrap, .lf-desc__text, .lf-desc__note, .lf-cta__content, .lf-story__content, .lf-help, .lf-stats__ctas, .lf-products__more', 'up'],
    ['.lf-marquee', 'fade'],
    ['.lf-story__media, .lf-article__media', 'media']
  ];

  var SKIP = '.lf-hero, .lf-intro, .lf-pdp__info, .lf-pdp__gallery, .lf-calc__intro, .lf-calc__grid, cart-drawer, .lf-footer';

  var parseNumber = function (text) {
    var match = text.match(/^([^\d]*)(\d[\d.,]*)(.*)$/);
    if (!match) return null;
    var raw = match[2];
    var info = { prefix: match[1], suffix: match[3], decimals: 0, thousands: '', original: text };
    if (/^\d{1,3}(\.\d{3})+$/.test(raw)) {
      info.thousands = '.';
      info.value = parseInt(raw.replace(/\./g, ''), 10);
    } else if (/^\d+,\d+$/.test(raw)) {
      info.decimals = raw.split(',')[1].length;
      info.value = parseFloat(raw.replace(',', '.'));
    } else if (/^\d+$/.test(raw)) {
      info.value = parseInt(raw, 10);
    } else {
      return null;
    }
    return info.value > 0 ? info : null;
  };

  var formatNumber = function (value, info) {
    var text = value.toFixed(info.decimals);
    if (info.decimals) text = text.replace('.', ',');
    if (info.thousands) text = text.replace(/\B(?=(\d{3})+(?!\d))/g, info.thousands);
    return info.prefix + text + info.suffix;
  };

  var runCount = function (el) {
    var info = el._lfCount;
    if (!info || info.running) return;
    info.running = true;
    var duration = 1700;
    var start = null;
    var step = function (time) {
      if (start === null) start = time;
      var progress = Math.min(1, (time - start) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = progress < 1 ? formatNumber(info.value * eased, info) : info.original;
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  };

  var prepareCount = function (el) {
    if (el._lfCount) return el._lfCount;
    var info = parseNumber(el.textContent.trim());
    if (!info) return null;
    el._lfCount = info;
    el.textContent = formatNumber(0, info);
    return info;
  };

  var inView = function (el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < (window.innerHeight || root.clientHeight);
  };

  var finishReveal = function (el) {
    el.classList.remove('lf-reveal', 'lf-reveal--up', 'lf-reveal--fade', 'lf-reveal--media', 'is-in');
    el.style.removeProperty('--lf-d');
  };

  var reveal = function (el, delay) {
    el.style.setProperty('--lf-d', delay + 'ms');
    el.classList.add('is-in');
    el.querySelectorAll('.lf-stat__num').forEach(function (num) {
      if (num._lfCount) window.setTimeout(function () { runCount(num); }, delay + 150);
    });
    window.setTimeout(function () { finishReveal(el); }, delay + 2000);
  };

  var observer = null;
  if (!reduce && !designMode && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      var visible = entries.filter(function (entry) { return entry.isIntersecting; }).map(function (entry) { return entry.target; });
      visible.sort(function (a, b) {
        var ra = a.getBoundingClientRect();
        var rb = b.getBoundingClientRect();
        return Math.abs(ra.top - rb.top) > 24 ? ra.top - rb.top : ra.left - rb.left;
      });
      visible.forEach(function (el, index) {
        observer.unobserve(el);
        reveal(el, Math.min(index, 6) * 90);
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
  }

  var setupReveals = function (scope) {
    if (!observer) return;
    GROUPS.forEach(function (group) {
      scope.querySelectorAll(group[0]).forEach(function (el) {
        if (el.closest(SKIP)) return;
        if (el.closest('.lf-reveal') || el.querySelector('.lf-reveal')) return;
        if (el.dataset.lfMotion) return;
        el.dataset.lfMotion = '1';
        if (inView(el)) return;
        el.classList.add('lf-reveal', 'lf-reveal--' + group[1]);
        el.querySelectorAll('.lf-stat__num').forEach(prepareCount);
        observer.observe(el);
      });
    });
  };

  var setupHeroCounts = function (scope) {
    if (reduce || designMode) return;
    var now = window.performance && window.performance.now ? window.performance.now() : 0;
    if (now > 700) return;
    scope.querySelectorAll('.lf-hero .lf-stat__num').forEach(function (el) {
      if (el._lfCount || !inView(el)) return;
      if (prepareCount(el)) {
        window.setTimeout(function () { runCount(el); }, Math.max(60, 820 - now));
      }
    });
  };

  var parallaxItems = [];
  var parallaxTicking = false;
  var updateParallax = function () {
    parallaxTicking = false;
    var vh = window.innerHeight || root.clientHeight;
    parallaxItems.forEach(function (item) {
      var box = item.box.getBoundingClientRect();
      if (box.bottom < -100 || box.top > vh + 100) return;
      var center = box.top + box.height / 2;
      var limit = box.height * 0.08;
      var shift = (vh / 2 - center) * 0.14;
      if (shift > limit) shift = limit;
      if (shift < -limit) shift = -limit;
      item.bg.style.setProperty('--lf-py', shift.toFixed(1) + 'px');
    });
  };

  var requestParallax = function () {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(updateParallax);
  };

  var setupParallax = function (scope) {
    if (reduce || designMode) return;
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    scope.querySelectorAll('.lf-hero__box, .lf-cta__box').forEach(function (box) {
      var bg = box.querySelector('.lf-hero__bg, .lf-cta__bg');
      if (!bg || bg._lfParallax) return;
      bg._lfParallax = true;
      parallaxItems.push({ box: box, bg: bg });
    });
    if (parallaxItems.length) updateParallax();
  };

  var setupCalculator = function (scope) {
    scope.querySelectorAll('[data-lf-calc-cal]').forEach(function (cal) {
      if (cal._lfMotion) return;
      cal._lfMotion = true;
      var index = function () {
        Array.prototype.forEach.call(cal.children, function (day, i) {
          day.style.setProperty('--i', i);
        });
      };
      index();
      new MutationObserver(index).observe(cal, { childList: true });
    });
    if (reduce) return;
    scope.querySelectorAll('[data-lf-calc-window], [data-lf-calc-ov], [data-lf-calc-next]').forEach(function (value) {
      if (value._lfMotion) return;
      value._lfMotion = true;
      var last = value.textContent;
      new MutationObserver(function () {
        if (value.textContent === last) return;
        last = value.textContent;
        value.classList.remove('lf-pop');
        void value.offsetWidth;
        value.classList.add('lf-pop');
      }).observe(value, { childList: true, characterData: true, subtree: true });
    });
  };

  var init = function (scope) {
    setupReveals(scope);
    setupHeroCounts(scope);
    setupParallax(scope);
    setupCalculator(scope);
  };

  var start = function () {
    init(document);
    window.addEventListener('scroll', function () { if (parallaxItems.length) requestParallax(); }, { passive: true });
    window.addEventListener('resize', function () { if (parallaxItems.length) requestParallax(); });
    window.addEventListener('beforeprint', function () {
      document.querySelectorAll('.lf-reveal').forEach(function (el) { el.classList.add('is-in'); });
    });
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  };

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
